// extracted by mini-css-extract-plugin
module.exports = {"Heatmap":"Heatmap_Heatmap__2b8kT"};